import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ListEenMediaMutationVariables = Types.Exact<{
  input: Types.EenListMediaInput;
}>;


export type ListEenMediaMutation = { __typename?: 'mutation_root', een_list_media?: { __typename?: 'EenListMediaOutput', data: string } | null };


export const ListEenMediaDocument = gql`
    mutation listEenMedia($input: EenListMediaInput!) {
  een_list_media(input: $input) {
    data
  }
}
    `;
export type ListEenMediaMutationFn = Apollo.MutationFunction<ListEenMediaMutation, ListEenMediaMutationVariables>;

/**
 * __useListEenMediaMutation__
 *
 * To run a mutation, you first call `useListEenMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useListEenMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [listEenMediaMutation, { data, loading, error }] = useListEenMediaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListEenMediaMutation(baseOptions?: Apollo.MutationHookOptions<ListEenMediaMutation, ListEenMediaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ListEenMediaMutation, ListEenMediaMutationVariables>(ListEenMediaDocument, options);
      }
export type ListEenMediaMutationHookResult = ReturnType<typeof useListEenMediaMutation>;
export type ListEenMediaMutationResult = Apollo.MutationResult<ListEenMediaMutation>;
export type ListEenMediaMutationOptions = Apollo.BaseMutationOptions<ListEenMediaMutation, ListEenMediaMutationVariables>;